/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Accordion, AccordionHeader, AccordionPanel, Typography2 } from '@coursera/cds-core';

type Props = {
  label: string;
  children: string & React.ReactNode;
  additionalInfo?: string;
};

const styles = {
  contentContainer: () => css`
    padding: var(--cds-spacing-150) 0;
  `,
};

const QuizSolution = ({ label, additionalInfo = 'Expand to view solution', children }: Props) => {
  return (
    <Accordion variant="standard">
      <AccordionHeader label={label}>
        <Typography2 component="p" color="supportText" variant="bodySecondary">
          {additionalInfo}
        </Typography2>
      </AccordionHeader>
      <AccordionPanel>
        <Typography2 component="p" css={styles.contentContainer} variant="bodyPrimary">
          {children}
        </Typography2>
      </AccordionPanel>
    </Accordion>
  );
};

export default QuizSolution;
